import React from "react";
import GitHubIcon from "@mui/icons-material/GitHub";
import Logo from "../../Assests/Images/logowhite.png";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import MailIcon from "@mui/icons-material/Mail";
import { useMediaQuery } from "@mui/material";
import CopyrightIcon from "@mui/icons-material/Copyright";

function Footer() {
  const isSmallScreen = useMediaQuery("(max-width:768px)");

  return (
    <footer>
      <div
        style={{
          padding: "5rem 1.5rem 2rem",
          backgroundColor: "#6E07F3",
          display: "flex",
          justifyContent: "center",
          flexDirection: isSmallScreen ? "column" : "column",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <div
          onClick={()=>window.scrollTo({ top: 0, behavior: 'smooth' })}
          style={{"cursor": "pointer"}}
        >
          <img alt="Logo" src={Logo} width="90px" />
        </div>

        <div style={{ width: isSmallScreen ? "" : "33.3333%" }}>
          <h1
            style={{
              fontSize: "1.4rem",
              margin: "2rem auto",
              maxWidth: "400px",
              opacity: 0.8,
              color: "white",
              textAlign: "center",
              fontWeight: 400,
              fontFamily: "Font2",
              lineHeight: 1.125,
              letterSpacing: 1.2,
            }}
          >
            Growing, learning, and improving step by step each day.
          </h1>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            color: "white",
            justifyContent: isSmallScreen ? "center" : "center",
            marginTop: isSmallScreen ? "20px" : "0",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              color: "white",
              padding: "12px",
              border: "1px solid white",
              borderRadius: "999px",
              cursor: "pointer",
              margin: "10px",
            }}
            onClick={() =>
              window.open("https://www.linkedin.com/in/kunalc123/", "_blank")
            }
          >
            <LinkedInIcon sx={{ fontSize: "28px" }} />
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              color: "white",
              padding: "12px",
              border: "1px solid white",
              borderRadius: "999px",
              cursor: "pointer",
              margin: "10px",
            }}
            onClick={() =>
              window.open("https://github.com/K-u-n-a-l-c", "_blank")
            }
          >
            <GitHubIcon />
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              color: "white",
              padding: "12px",
              border: "1px solid white",
              borderRadius: "999px",
              cursor: "pointer",
              margin: "10px",
            }}
            onClick={() =>
              (window.location = "mailto:workwithkunalc@gmail.com")
            }
          >
            <MailIcon />
          </div>
        </div>
        <div
          style={{
            color: "white",
            display: "flex",
            justifyContent: "center",
            marginTop: "60px",
            marginBottom: "40px",
            opacity: 0.8,
            alignItems: "center",
            fontSize: "18px",
          }}
        >
          Handcrafted by me &nbsp;
          <CopyrightIcon />
          &nbsp; 2024
        </div>
      </div>
    </footer>
  );
}

export default Footer;
